<!-- 2 -->
<template>
  <div class="content-block">
    <!-- ヘッダー -->
    <DbsHeader
      header-title="利用状況"
      :click-back-button-event="backToDbsIndexPage"
    />

    <img
      class="reload"
      :src="require(`@/assets/img/icon/png/reload.png`)"
      @click="reloadAPI"
    />

    <div class="block">
      <div class="scrollable-filed">
        <div v-if="propMyReservation.status == 'started'">
          <img :src="require(`@/assets/img/icon/png/status_use.png`)" />
          <p class="status">利用中</p>
        </div>
        <div v-else>
          <img :src="require(`@/assets/img/icon/png/status_end.png`)" />
          <p class="status">返却完了</p>
        </div>

        <CycleInfo
          label="ポート名"
          :value="propMyReservation.start_park_name"
        />
        <CycleInfo label="乗車ID" :value="propMyReservation.id" />
        <CycleInfo label="バイク番号" :value="propMyReservation.cyc_name" />
        <CycleInfo label="ご利用時間" :value="propUtilizationTime" />

        <CycleInfo
          v-if="propMyReservation.status == 'none'"
          label="お支払い金額"
          :value="String(propMyReservation.emot_fee) + '円'"
        />
        <CycleInfo
          v-if="
            propMyReservation.status == 'none' &&
            propMyReservation.coupons.length > 0
          "
          label="ご利用クーポン"
          :value="propMyReservation.coupons[0].master_pass_name"
        />

        <CycleInfoPasscode
          v-if="
            propMyReservation.status == 'started' && propMyReservation.passcode
          "
          :value="propMyReservation.passcode"
        />

        <DbsHowToUseLinkButton
          v-if="propMyReservation.status == 'started'"
          style="margin-top: 5%"
        />

        <DbsBeforeUnlockCaution
          v-if="
            propMyReservation.status == 'started' &&
            !isPasscodeType &&
            usingCycCsaName
          "
        />
      </div>

      <DbsUnlockingBottomButtons
        v-if="propMyReservation.status == 'started' && !isPasscodeType"
        :is-passcode-type="isPasscodeType"
        :using-cyc-csa-name="usingCycCsaName"
        :is-reserve="false"
      />
    </div>
  </div>
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import API from "@/API";
import { useRoute } from "vue-router";

export default {
  name: "TemplateDbsMyUsing",
  props: {
    propMyReservation: {
      type: Object,
      required: true,
    },
    propUtilizationTime: {
      type: String,
      required: true,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute();

    const isPasscodeType =
      props.propMyReservation.status != "none"
        ? props.propMyReservation.cycle_info.csa_type == 0
        : null;
    const usingCycCsaName = route.query.cyc_csa_name;

    const backToDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsWithClose();
    };

    const reloadAPI = async () => {
      await API.getDbsReservation();
      if (props.propMyReservation.status == "none") {
        await API.getDbsReportsForUsing();
      }
    };

    return {
      backToDbsIndexPage,
      reloadAPI,
      isPasscodeType,
      usingCycCsaName,
    };
  },
};
</script>

<style scoped>
.content-block {
  width: 98%;
  max-width: 500px;
  display: block;
  margin: auto;
}

.reload {
  width: 50px;
  position: absolute;
  top: 0;
  right: 0;
  margin: 35px 20px 0px 0px;
}

.content-block .block {
  text-align: center;
}

.content-block .block .scrollable-filed {
  margin-bottom: 160px;
}

.content-block .block div {
  margin-bottom: 5%;
}

.content-block .block div img {
  width: 40%;
  margin: 5%;
}

.content-block .block .status {
  font-weight: bold;
  text-align: center;
  font-size: 1.3rem;
}
</style>
